import React, { Component } from 'react';
import { Radio, Input } from 'antd';
import {request} from '../utils/Util'
import {connect} from 'react-redux';
import myEmitter from "../component/my-events";
import {FormattedMessage, injectIntl} from 'react-intl';
import {Match} from "../component/MatchAnalysis";
import {Reading} from "../component/ReadingAnalysis";
import {ScienceAnalysis} from "../component/ScienceAnalysis";
import {English} from "../component/EnglishAnalysis";
import demo from '../imgs/demo.jpg'
import './QuestionItem.css';
import {Pagination} from "react-bootstrap";
import {bindActionCreators} from "redux";
import * as actions from "../actions/evaluation";
const RadioGroup = Radio.Group;




const QuestionWrapper = (WrappedComponent) => {
    class NewComponent extends Component {

        render() {
            return <WrappedComponent {...this.props}/>
        }
    }

    return connect(state => ({

    }))(NewComponent)
}

class Item extends Component {
    constructor(props) {
        super(props);
        // 初始状态
        this.state={
            value: ''
        }
    }

    handelPageItemClick(i){
        const {actions,currentEvaluation,answerActions} = this.props;
        // var newPage = {page:i};
        currentEvaluation.page = i;
        actions.setCurrentEvaluation(currentEvaluation);
        myEmitter.emit('nextQuestion');
    }

    handelWrongPagePrev(){
        const {currentEvaluation} = this.props;
        var curWrongPage = currentEvaluation.curWrongPage;
        if(curWrongPage>1){
            currentEvaluation.curWrongPage -= 1;
            this.getData(currentEvaluation.test_id, curWrongPage-1);
        }else{
            alert("已经到第一页");
        }
    }

    handelWrongPageNext(){
        const {currentEvaluation} = this.props;
        var curWrongPage = currentEvaluation.curWrongPage;
        if(curWrongPage<currentEvaluation.totalPage){
            currentEvaluation.curWrongPage += 1;
            this.getData(currentEvaluation.test_id, curWrongPage+1);
        }else{
            alert("已经到最后一页");
        }

    }
    async getData(testId, page){
        const {actions, currentEvaluation} = this.props;
        const questions = await request(`/questionnaires/test_record/`,'get',{test_id:testId,pages:page});
        actions.setAnalysisEvaluation(questions.detail);
        currentEvaluation.page = 0;
        actions.setCurrentEvaluation(currentEvaluation);
        // actions.setCurrentEvaluation({page: 0});
        // this.setState({count:questions.detail.count,test_num: questions.detail.test_num, page:page})
        // console.log(questions);
    }

    _getQuestion() {
        const {evaluation,currentEvaluation} = this.props;
        var currnt = Object.values(Object.values(evaluation.datas[currentEvaluation.page])[0]);
        console.log(currnt);
        if (currnt && Object.values(currnt)[0].test === 'math') { // 单选填空题
            return QuestionWrapper(Match);
        }else if( currnt && Object.values(currnt)[0].test === 'science'){
            return QuestionWrapper(ScienceAnalysis);
        }else if( currnt && Object.values(currnt)[0].test === 'english'){
            return QuestionWrapper(English);
        }else if( currnt && Object.values(currnt)[0].test === 'reading'){
            return QuestionWrapper(Reading);
        }
    }


    render() {
        const {evaluation,currentEvaluation,setAnswerFn} = this.props;
        // console.log(JSON.parse(evaluation.datas.content_object_content),'页面数据');

        var PaginationItem=[];
        if(evaluation.datas.length > 0) {
            for (var i = 0; i < evaluation.datas.length; i++) {
                var number = i+1;
                for(var k in evaluation.datas[i]){for(var index in  evaluation.datas[i][k]){number = evaluation.datas[i][k][index].number}}
                PaginationItem.push(< Pagination.Item  key={i}
                                                      active={i === currentEvaluation.page}
                                                      onClick={this.handelPageItemClick.bind(this, i)}> {number} </ Pagination.Item>)
            }
        }

        const QuestionModel = currentEvaluation.page > -1 ? this._getQuestion() : '';
        return (
            <div className='' style={{position:'relative',height:'100%'}}>

                {
                    currentEvaluation.page > -1 &&   <QuestionModel  />
                }
                <aside className='asider'>
                    {/*<Pagination pageSizeOptions={[1,10,100,200]} current={this.state.current} onChange={this.onChange} total={500} />*/}
                    < Pagination >
                            < Pagination.First className="page_lf"  onClick={this.handelWrongPagePrev.bind(this)}/>
                        {PaginationItem}
                        < Pagination.Last className="page_lf"   onClick={this.handelWrongPageNext.bind(this)}/>
                        <p className="pageDesc">当前{currentEvaluation.curWrongPage}页 / 共{currentEvaluation.totalPage}页</p>
                    </ Pagination >
                </aside>
            </div>

        );
    }
}
Item = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
}), (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
}))(Item);



export default Item;
